


























import { Component, Vue } from 'vue-property-decorator';
import * as THREE from 'three';
import { GLTFLoader } from '@/three/loaders/GLTFLoader.js';
import { OrbitControls } from '@/three/controls/OrbitControls.js';
import { RoomEnvironment } from '@/three/environments/RoomEnvironment.js';

// GLTF模型预览(通过移动相机轨道来变更视角)
@Component
export default class GltfOrbitPreview extends Vue {
  public gltfUri = '';    // gltf 文件路径
  public errMsg = '';     // gltf 加载出错时的信息
  public percent = 0;     // gltf 加载进度
  public loading = false; // gltf 是否加载中

  public camera!: any;
  public scene!: any;
  public renderer!: any;

  public mounted() {
    this.gltfUri = (this.$route.query.url || '') as string;
    if (this.gltfUri) {
      this.init();
      this.render1();
      window.addEventListener('resize', this.onWindowResize);
    }
  }

  public init() {
    const { container, ctWidth, ctHeight } = this.getHtmlCt();

    // 透视投影相机
    // 如果希望渲染的结果符合人眼的远小近大的规律，选择透视投影相机 PerspectiveCamera
    // 如果不需要模拟人眼远小近大的投影规律，可以选择正投影相机 OrthographicCamera
    const fov = 45;     // 拍摄距离
    const far = 20;     // 最大范围
    const near = 0.25;  // 最小范围
    this.camera = new THREE.PerspectiveCamera(fov, ctWidth / ctHeight, near, far);
    this.camera.position.set(-2.5, 0.6, 3.0);

    // 渲染器
    this.renderer = new THREE.WebGLRenderer({ antialias: true });
    this.renderer.setPixelRatio(window.devicePixelRatio);
    this.renderer.setSize(ctWidth, ctHeight);
    container.appendChild(this.renderer.domElement);

    // 场景
    const pmremGenerator = new THREE.PMREMGenerator(this.renderer);
    const roomEnv = new RoomEnvironment(this.renderer);
    this.scene = new THREE.Scene();
    this.scene.background = new THREE.Color(0xf0f0f0);
    this.scene.environment = pmremGenerator.fromScene(roomEnv, 0.04).texture;

    // 加载 gltf
    this.loading = true;
    this.percent = 0;
    this.errMsg = '';
    // this.loading = { value: true, percent: 0, errMsg: '' };
    const loader = new GLTFLoader();
    loader.load(this.gltfUri, (gltf: any) => {
      this.scene.add(gltf.scene);
      const shadowMesh = this.createSpotShadowMesh();
      shadowMesh.position.y = -1.1;
      shadowMesh.position.z = -0.25;
      shadowMesh.scale.setScalar(2);
      this.scene.add(shadowMesh);
      this.render1();

      // 延迟 300ms 是为了让进度条渲染完成后, 再进入场景
      // 如果不延迟, 会出现进度值是 100%, 但是进度条只渲染了一半, 就进入了场景的情况
      setTimeout(() => { this.loading = false; }, 300);
    }, (xhr: any) => {
      // 加载中时, 获取加载进度值
      this.loading = true;
      this.percent = Math.floor(xhr.loaded / xhr.total * 100);
    }, (err: any) => {
      // 加载出错时
      this.loading = true;
      this.percent = 0;
      this.errMsg = `加载出错：${err.message}`;
      throw new Error(err);
    });

    // 相机轨道控制器
    const controls = new OrbitControls(this.camera, this.renderer.domElement);
    controls.addEventListener('change', this.render1); // use if there is no animation loop
    controls.minDistance = 2;
    controls.maxDistance = 20;
    controls.enablePan = false; // 禁止右键移动(禁止摄像机水平或垂直平移)
    controls.target.set(0, -0.15, -0.2);
    controls.update();  // 函数内会执行 camera.lookAt(controls.target)
  }

  public createSpotShadowMesh() {
    const canvas = document.createElement( 'canvas' );
    canvas.width = 128;
    canvas.height = 128;

    const context = canvas.getContext( '2d' )!;
    const gradient = context.createRadialGradient(
      canvas.width / 2,
      canvas.height / 2,
      0,
      canvas.width / 2,
      canvas.height / 2,
      canvas.width / 2,
    );
    gradient.addColorStop( 0.1, 'rgba(130,130,130,1)' );
    gradient.addColorStop( 1, 'rgba(255,255,255,1)' );

    context.fillStyle = gradient;
    context.fillRect( 0, 0, canvas.width, canvas.height );

    const shadowTexture = new THREE.CanvasTexture( canvas );

    const geometry = new THREE.PlaneGeometry();
    const material = new THREE.MeshBasicMaterial({
      map: shadowTexture, blending: THREE.MultiplyBlending, toneMapped: false,
    });

    const mesh = new THREE.Mesh( geometry, material );
    mesh.rotation.x = - Math.PI / 2;

    return mesh;
  }

  // 循环渲染(不能用 this.render 来命名)
  public render1() {
    this.renderer.render(this.scene, this.camera);
  }

  // 画布跟随窗口变化
  public onWindowResize() {
    const { ctWidth, ctHeight } = this.getHtmlCt();
    this.camera.aspect = window.innerWidth / window.innerHeight;
    this.camera.updateProjectionMatrix();
    this.renderer.setSize(ctWidth, ctHeight);
    this.render1();
  }

  // 获取 html 容器尺寸信息
  public getHtmlCt(domSelector = '#container') {
    const container = document.querySelector(domSelector) as HTMLElement;
    const ctWidth = (container.parentElement as HTMLElement).clientWidth;
    const ctHeight = (container.parentElement as HTMLElement).clientHeight;
    return { container, ctWidth, ctHeight };
  }
}
